import { Component } from "react";
import "./TranslationTool.css";
import TranslationInput from "./components/TranslationInput/TranslationInput";
import GoogleTranslateAttributionBadge from "./../../../../../GoogleTranslateAttributionBadge/GoogleTranslateAttributionBadge";
import { translate } from "services/translate";
import { getSessionUser } from "services/authUtil";
import { TRANSLATE_OBJ } from "model/translate";
import Action from "./../../../../../formElements/Action/Action";
import switchImg from "./images/switch.svg";
import { Translation } from "react-i18next";

const DEFAULT_SRC_LANG = "en";
const DEFAULT_ERROR_TEXT = "Tool.somethingWrong";

export default class TranslationTool extends Component {
  constructor(props) {
    super(props);

    this.state = {
      srcText: this.props.defaultText || this.props.previousState.srcText || "",
      srcLang: this.props.previousState.srcLang || DEFAULT_SRC_LANG,
      targetText: this.props.previousState.targetText || "",
      targetLang:
        this.props.previousState.targetLang || getSessionUser().profile.native_language,
      showSpinner: false,
      errors: [],
    };

    this.onSrcLangChanged = this.onSrcLangChanged.bind(this);
    this.onTargetLangChanged = this.onTargetLangChanged.bind(this);
    this.onSrcTextChanged = this.onSrcTextChanged.bind(this);
    this.onTargetTextChanged = this.onTargetTextChanged.bind(this);
    this.switchLanguages = this.switchLanguages.bind(this);
    this.doTranslate = this.doTranslate.bind(this);
    this.getStateToSave = this.getStateToSave.bind(this);
  }

  componentWillUpdate(nextProps) {
    if (nextProps.defaultText !== this.props.defaultText) {
      this.setState({ srcText: nextProps.defaultText, targetText: "" });
    }
  }

  onSrcLangChanged(lang) {
    this.setState({ srcLang: lang ? lang.code : null });
  }

  onTargetLangChanged(lang) {
    // We also change target text because if you changed target language,
    // then the old text becomes invalid for the new language.
    this.setState({ targetLang: lang ? lang.code : null, targetText: "" });
    if (lang && this.state.srcText) {
      this.doTranslate(null, lang.code);
    }
  }

  onSrcTextChanged(evt) {
    this.setState({ srcText: evt.target.value });
  }

  onTargetTextChanged(evt) {
    this.setState({ targetText: evt.target.value });
  }

  switchLanguages() {
    if (this.state.showSpinner) {
      // Disable actions when translation is in progress.
      return;
    }
    this.setState({
      srcText: this.state.targetText,
      srcLang: this.state.targetLang,
      targetText: this.state.srcText,
      targetLang: this.state.srcLang,
    });
  }

  doTranslate(event, targetLang) {
    if (this.state.showSpinner) {
      // Disable actions when translation in progress.
      return;
    }
    if (!targetLang) {
      targetLang = this.state.targetLang;
    }
    if (!this.state.srcText || !targetLang) {
      const errors = [];
      if (!this.state.srcText) {
        errors.push("Tool.pleaseEnterText");
      }
      if (!targetLang) {
        errors.push("Tool.pleaseSelectLang");
      }
      this.setState({ errors: errors });
      return;
    }
    this.setState({ errors: [], showSpinner: true });
    translate(
      {
        targetLang: targetLang,
        srcLang: this.state.srcLang,
        srcText: this.state.srcText,
      },
      resp => {
        this.setState({ targetText: resp.translated_text, showSpinner: false });
      },
      errors => {
        const newState = { showSpinner: false };
        if (errors && errors.description) {
          newState.errors = [errors.description];
        } else {
          newState.errors = [DEFAULT_ERROR_TEXT];
        }
        this.setState(newState);
      }
    );
  }

  getStateToSave() {
    return {
      srcText: this.state.srcText,
      srcLang: this.state.srcLang,
      targetText: this.state.targetText,
      targetLang: this.state.targetLang,
    };
  }

  render() {
    return (
      <Translation>
        {t => (
          <div className="translation-tool">
            {this.state.errors.map((er, index) => (
              <div className="talaera-form-error" key={index}>
                {er.includes("Tool.") ? t(er) : er}
              </div>
            ))}
            <TranslationInput
              value={this.state.srcText}
              lang={this.state.srcLang}
              placeholder={t("Tool.enterWord")}
              maxLength={TRANSLATE_OBJ.text.maxLength}
              onLangChanged={this.onSrcLangChanged}
              onTextChanged={this.onSrcTextChanged}
            />
            <div className="actions">
              <Action
                className="btn switch-btn"
                title={t("Tool.switchLang")}
                onClick={this.switchLanguages}
              >
                <img src={switchImg} alt="switch" className="switch" />
              </Action>
              <button className="btn" onClick={this.doTranslate}>
                {t("Tool.Translate")}
              </button>
            </div>
            <TranslationInput
              value={this.state.targetText}
              lang={this.state.targetLang}
              placeholder={t("Tool.findTranslation")}
              readOnly={true}
              disabled={true}
              showSpinner={this.state.showSpinner}
              onLangChanged={this.onTargetLangChanged}
              onTextChanged={this.onTargetTextChanged}
            />
            <GoogleTranslateAttributionBadge />
          </div>
        )}
      </Translation>
    );
  }
}
